<template>

	<div id="app">

		<router-view name="rv-container"></router-view>

	</div>

</template>

<script>
export default {
	name: "layoutPage",
}
</script>

<style scoped>

</style>